import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';

function toCamel(input: string): string {
    if (input.includes('_')) {
    return input.toLowerCase().replace(/_([a-z])/g, (match) => match[1].toUpperCase());
  }

  if (input === input.toUpperCase()) {
    return input.toLowerCase();
  }

  return input.charAt(0).toLowerCase() + input.slice(1);
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return value !== null &&
         typeof value === 'object' &&
         !Array.isArray(value) &&
         value.constructor === Object;
}

function keysToCamel<T>(data: unknown): T {
  if (Array.isArray(data)) {
    return data.map(item => keysToCamel(item)) as unknown as T;
  }

  if (isPlainObject(data)) {
    return Object.entries(data).reduce<Record<string, unknown>>((result, [key, value]) => {
      result[toCamel(key)] = keysToCamel(value);
      return result;
    }, {}) as T;
  }

  return data as T;
}

export const camelCaseInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    map(event => {
      if (!(event instanceof HttpResponse) || !event.body || typeof event.body !== 'object') {
        return event;
      }

      const camelCaseBody = keysToCamel(event.body);
      return event.clone({ body: camelCaseBody });
    })
  );
};
